import { SimpleCookie } from '~/assets/js/classes/Cookie';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from '~/assets/js/consts/storageKeys.const';
import { useApiClient } from '~/assets/js/network/axios_init';
import { logoutUser } from '~/assets/js/api/auth.api';
import { useUserStore } from '~/store/StoreUser';
import Caching from '~/assets/js/classes/Caching';
import is_dev from '~/assets/js/functions/is_dev';
import { unset_openreply_user } from '~/assets/js/plugins/openreply';
import { unset_sentry_user } from '~/assets/js/plugins/sentry';
import { useRequestURL } from 'nuxt/app';
import getBaseDomain from '~/assets/js/functions/getBaseDomain';

const useAuth = () => {
  const url = useRequestURL();
  const baseDomain = getBaseDomain(url.hostname);

  const authCookie = SimpleCookie.create(KEY_ACCESS_TOKEN, {
    domain: baseDomain,
  });

  const refreshCookie = SimpleCookie.create(KEY_REFRESH_TOKEN, {
    domain: baseDomain,
  });

  const getAuthToken = () => {
    return authCookie.get() || null;
  };

  const saveAuthToken = token => {
    authCookie.set(token, 90);
  };

  const clearAuthToken = () => {
    authCookie.remove();
  };

  const getRefreshToken = () => {
    return refreshCookie.get() || null;
  };

  const saveRefreshToken = token => {
    refreshCookie.set(token, 90);
  };

  const clearRefreshToken = () => {
    refreshCookie.remove();
  };

  function auth_user(token, refresh = null) {
    saveAuthToken(token);
    // saveRefreshToken(refresh);
    useApiClient().setToken(token);
  }

  function make_logout() {
    const userStore = useUserStore();
    userStore.make_empty();
    delete useApiClient().axiosClient.defaults.headers.common['Authorization'];

    clearAuthToken();
    clearRefreshToken();
    Caching.bust_caches();

    if (!is_dev()) {
      unset_openreply_user();
      unset_sentry_user();
    }

    navigateTo({ name: 'auth.login' });
  }

  function logout(params) {
    return logoutUser(params)
      .finally(() => {
        make_logout();
      })
      .catch(() => {
        make_logout();
      });
  }

  function is_auth() {
    return getAuthToken();
  }

  return {
    authCookie,
    refreshCookie,
    getAuthToken,
    saveAuthToken,
    clearAuthToken,
    getRefreshToken,
    saveRefreshToken,
    clearRefreshToken,
    make_logout,
    logout,
    is_auth,
    auth_user,
  };
};

export default useAuth;
